import slice from "./dataRefreshesSlice";

export default slice.reducer;
